export const ACCOUNT_PLANS = [
  {
    key: 'personal',
    group: 'Personal',
    name: 'Personal',
    monthlyPrice: '10.00',
    annualPrice: '100.00',
    trialDays: 15,
    features: [
      'Track personal income and expenses',
      'Create and manage budgets',
      'Monitor multiple accounts',
      'Track investments and assets',
      'Plan for financial goals',
      'One location',
      '15-day free trial (card required, cancel before day 15 and you are not charged)'
    ]
  },
  {
    key: 'basic',
    group: 'Business',
    name: 'Basic',
    monthlyPrice: '15.00',
    annualPrice: '150.00',
    features: [
      'Professional invoicing with your logo',
      'Accounts receivable tracking',
      'Payroll and staff management',
      'Asset and liability tracking',
      'Comprehensive financial reports',
      'One location'
    ]
  },
  {
    key: 'premium',
    group: 'Business',
    name: 'Premium',
    monthlyPrice: '30.00',
    annualPrice: '300.00',
    features: [
      'Professional invoicing with your logo',
      'Accounts receivable tracking',
      'Payroll and staff management',
      'Asset and liability tracking',
      'Comprehensive financial reports',
      'One location included',
      'Each extra location is $5.00 a month or $50.00 a year'
    ]
  }
];

export function findAccountPlan(key) {
  return ACCOUNT_PLANS.find((plan) => plan.key === key) || null;
}

export function planAmount(plan, cycle) {
  return cycle === 'annual' ? plan.annualPrice : plan.monthlyPrice;
}

export function planStartLabel(plan) {
  return plan.trialDays ? `Start ${plan.trialDays}-day free trial` : `Choose ${plan.name}`;
}

export function planCycleLabel(cycle) {
  return cycle === 'annual' ? 'year' : 'month';
}
